<template>
    <div>

        <div>

            <div class="card dashcard mb-3">
            
                <div class="card-body">

                    <div class="form-row">
                        <div class="col col-12 col-md-6">
                            <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                icon="fas fa-filter fa-fw"
                                placeholder="Todas"
                                type="select"
                                :optionsList="[
                                    { id: 'X', search: 'Aguardando Aprovação' },
                                    { id: 'A', search: 'Aprovadas' },
                                    { id: 'E', search: 'Em Edição' },
                                    { id: 'N', search: 'Não Aprovadas' },
                                    { id: 'I', search: 'Inativas' }, 
                                ]"
                                optionsData="id"
                                optionsMode="json"
                                v-model="filtros.status_aprovacao" />
                        </div>

                        <div class="col col-12 col-md-3">
                            <az-input
                                icon="fas fa-truck-loading fa-fw"
                                placeholder="Todas"
                                type="select"
                                :optionsList="[
                                    { id: 'R', search: 'Recebida Total/Parcial' },
                                    { id: 'T', search: 'Recebida Total' },
                                    { id: 'P', search: 'Recebida Parcial' },
                                    { id: 'F', search: 'Recebida Parcial/Não Recebida' },
                                    { id: 'N', search: 'Não Recebida' },
                                ]"
                                optionsData="id"
                                optionsMode="json"
                                :edicao="filtros.status_aprovacao == 'A'"
                                v-model="filtros.status_recebimento" />
                        </div>
                        
                    </div>

                    <div class="form-row mt-2">
                        <div class="col col-12 col-md-2"> 
                            <az-input
                                icon="fa-regular fa-calendar fa-fw"
                                placeholder="Data da OC"
                                type="select"
                                :optionsList="[
                                    { id: 'entrega', search: 'Data da Entrega' }, 
                                ]"
                                optionsData="id"
                                optionsDisplay="search"
                                optionsMode="json"
                                v-model="filtros.tipo_data" />
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input
                                placeholder="Todos os fornecedores..."
                                icon="fas fa-industry fa-fw"
                                type="autocomplete"
                                optionsMode="aql"
                                service="fornecedores.index"
                                optionsData="id_fornecedor"
                                optionsDisplay="search"
                                v-model="filtros.id_fornecedor" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                icon="fab fa-google fa-fw"
                                placeholder="Todos os Grupos..."
                                type="select"
                                service="estoque_grupos.index"
                                optionsData="id_estoque_grupo"
                                optionsMode="aql"
                                v-model="filtros.id_estoque_grupo" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                placeholder="Todos o itens..."
                                icon="fa-solid fa-box fa-fw"
                                type="autocomplete" 
                                optionsMode="aql"
                                service="estoque_items.index"
                                optionsData="id_estoque_item"
                                v-model="filtros.id_estoque_item" />
                        </div>
                    </div>

                    <div class="form-row mt-2">
                        <div class="col col-12 col-md-2"> 
                            <az-input
                                icon="fa fa-filter fa-fw"
                                placeholder="Status..."
                                type="select"
                                :optionsList="lista_status"
                                optionsData="id_contato_status"
                                optionsDisplay="search"
                                optionsMode="json"
                                :edicao="( lista_status && lista_status.length ) ? true : false"
                                v-model="filtros.id_contato_status" />
                        </div>

                        <div class="col col-12 col-md-2">
                            <az-input
                                icon="far fa-building fa-fw"
                                type="select"
                                placeholder="Todas as Unidades..."
                                :optionsList="$util.unidades_com_tags(true, true)"
                                optionsData="id_unidade_operacao"
                                v-model="filtros.id_unidade_operacao" />
                        </div>

                        <div class="col col-12 col-md-2">
                            <az-input
                                icon="fa-solid fa-c fa-fw"
                                type="select"
                                placeholder="Todos..."
                                :optionsList="[
                                    { id: 'S', search: 'Consignados' },
                                    { id: 'N', search: 'Não Consignados' }
                                ]"
                                optionsData="id"
                                v-model="filtros.busca_consig" />
                        </div>

                        <div class="col col-12 col-md-3">
                            <az-input 
                                icon="fas fa-search fa-fw" 
                                placeholder="(Digite # + número da OC, para pesquisar uma OC específica)"
                                v-model="search" />
                        </div>

                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'A'">
                                    Ativos
                                </button>
                                <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'T'">
                                    Todos
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma ordem de compra identificada.'" 
                icon="fas fa-shopping-cart" />
		</div>

        <div v-if="lista && lista.length">

            <div class="form-row mb-3">
                <div class="col col-12 d-flex flex-column">
                    <az-input   
                        type="button-group"
                        sizing="sm"
                        :optionsList="[
                            { id: 'OC', search: 'Ordens de Compra' },
                            { id: 'IT', search: 'Materiais / Medicamentos' },
                        ]"
                        v-model="viewType" />
                </div>
            </div>

            <!-- Lista de Ordens de Compra -->

            <template v-if="viewType == 'OC'">

                <div class="list-group mb-3 az-anime-surgir">
                    <li class="list-group-item hover-bg" v-for="(dado, id) in lista" :key="id">
                        <div class="d-flex justify-content-between">
                            <span>
                                <div>
                                    <a href="#" @click.prevent="view_oc (dado)" class="h5 card-link mb-0">
                                        {{ dado.search }} 
                                    </a>
                                    <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                    {{ $util.getFormatDate(dado.created_at) }}
                                    <template v-if="dado.aquisicao && dado.aquisicao.unidade_operacao">
                                        <span class="badge badge-light" :title="dado.aquisicao.unidade_operacao.st_nome">
                                            <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                            {{ dado.aquisicao.unidade_operacao.st_sigla }}
                                        </span>
                                    </template>
                                    <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                    {{ dado.fornecedor.search }}

                                    <span class="small text-muted mr-3" v-if="dado.is_consig">
                                        (Consig)
                                    </span>
                                </div>
                                <div>
                                    <a href="#" @click.prevent="registrar_contatos(dado)" class="card-link" v-if="lista_status && lista_status.length">
                                        <i class="fa fa-comment fa-fw mr-3" aria-hidden="true"></i>
                                    </a>
                                    <span class="small text-muted mt-2">
                                        {{ dado.lista_items }}
                                    </span>
                                </div>
                                <div v-if="dado.entregas && dado.entregas.length" title="Programação de Entrega">
                                    <i class="fa-regular fa-calendar-check fa-fw mr-3"></i>
                                    <span class="small text-muted">
                                        {{ dado.entregas.map(ent => $util.getFormatDate(ent.dt_entrega)).join(', ') }}
                                    </span>
                                </div>
                                <div v-if="dado.lista_atends && dado.lista_atends.length" title="Atendimentos Relacionados">
                                    <i class="fa fa-play fa-fw mr-3" aria-hidden="true"></i>
                                    <span class="small text-muted">
                                        {{ dado.lista_atends.map(atend => '#' + atend).join(', ') }}
                                    </span>
                                </div>
                            </span>
                            <span class="text-right">
                                <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                    <input type="checkbox" class="custom-control-input" 
                                        :id="'ativo-' + id" 
                                        v-model="dado.fl_ativo" 
                                        @change="toggle(dado)">
                                    <label class="custom-control-label" :for="'ativo-' + id"></label>
                                </div>
                                <template v-else-if="dado.fl_autorizado !== null">
                                    <h5>
                                        <span class="badge mr-1" :class="dado.log_envio_emails_count > 0 ? 'badge-info' : 'badge-secondary'" title="Envio ao Fornecedor">
                                            <i class="fas fa-share-square mr-1"></i>
                                            {{ dado.log_envio_emails_count }}
                                        </span>
                                        
                                        <span v-if="dado.status_aprovacao">
                                            <span class="badge" :class="'badge-' + dado.status_aprovacao.color">{{ dado.status_aprovacao.title }}</span>
                                        </span>
                                        <span class="badge badge-success" v-else-if="dado.fl_autorizado">Aprovada</span>
                                        <span class="badge badge-danger" v-else>Não Aprovada</span>
                                    </h5>
                                    <h5 v-if="dado.fl_autorizado">
                                        <span class="badge badge-success" v-if="dado.perc_recebida >= 100">Recebida Total</span>
                                        <span class="badge badge-warning" v-else-if="dado.perc_recebida > 0">Recebida Parcial</span>
                                        <span class="badge badge-secondary" v-else>Não Recebida</span>
                                    </h5>
                                </template>

                                <template v-else>
                                    <button type="button" class="btn btn-success mb-md-0 mb-1" @click="autorizar(dado)">
                                        <i class="fas fa-check fa-fw "></i>
                                    </button>
                                    <button type="button" class="btn btn-danger ml-0 ml-md-2" @click="autorizar(dado, false)">
                                        <i class="fas fa-times fa-fw "></i>
                                    </button>
                                </template>

                                <h5 v-if="dado.contatos && dado.contatos.length">
                                    <span class="badge" :class="'badge-' + dado.contatos[0].contato_status.st_color">
                                        {{ dado.contatos[0].contato_status.search }}
                                    </span>
                                </h5>
                            </span>
                        </div>

                        <div class="progress mb-1" v-if="dado.perc_recebida && dado.fl_autorizado">
                            <div class="progress-bar bg-success" role="progressbar" :style="'width: ' + dado.perc_recebida + '%'" v-if="dado.perc_recebida >= 100"></div>
                            <div class="progress-bar bg-warning" role="progressbar" :style="'width: ' + dado.perc_recebida + '%'" v-else-if="dado.perc_recebida"></div>
                            <div class="progress-bar bg-secondary" role="progressbar" style="width: 0%" v-else></div>
                        </div>

                        <div class="alert small mb-0 p-2" :class="dado.fl_autorizado ? 'alert-warning' : 'alert-danger'" v-if="dado.st_comentarios">
                            {{ dado.st_comentarios }}
                        </div>
                    </li>
                </div>

            </template>

            <!-- Lista de Ordens de Compra -->

            <template v-if="viewType == 'IT'">

                <div v-if="lista_classes && lista_classes.length">
                    <table class="table table-sm border-0 mb-0 table-responsive">
                        <tr>
                            <td class="text-nowrap">
                                <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                                    <span class="badge badge-success mr-1" >
                                        {{ classe }}
                                    </span>
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="text-right">
                    <a href="#" @click.prevent="detalhado = !detalhado" class="card-link ml-2">
                        <i class="fa-solid fa-minimize fa-fw" v-if="detalhado"></i>
                        <i class="fa-solid fa-maximize fa-fw" v-else></i>
                    </a>
                </div>

                <table class="table table-hover cabecalho-fixo bg-white table-responsive-md" :class="detalhado ? '' : 'table-sm'">
                    <thead>
                        <th>Id</th>
                        <th>Descrição</th>
                        <th>Unidade</th>
                        <th>Fornecedor</th>
                        <th class="text-right">OCs</th>
                        <th class="text-right">Solicitada</th>
                        <th class="text-right">Recebida</th>
                        <th class="text-right">Pendente</th>
                    </thead>
                    <tbody>
                        <tr v-for="(material, imx) in lista_materiais" :key="imx" :class="material.cor ? 'table-' + material.cor : ''">
                            <td>#{{ material.id }}</td>
                            <td>
                                {{ material.descricao }}
                                <div v-if="detalhado">
                                    <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, ilx) in material.classes" :key="ilx">
                                        <span class="badge badge-success mr-1" >
                                            {{ classe }}
                                        </span>
                                    </a>
                                </div>
                            </td>
                            <td class="small text-muted">{{ material.unidade }}</td>
                            <td class="small">{{ material.fornecedor }}</td>
                            <td class="text-right">{{ material.ocs }}</td>
                            <td class="text-right">{{ material.qtd_compra }}</td>
                            <td class="text-right">{{ material.qtd_receb }}</td>
                            <td class="text-right">{{ material.qtd_pend }}</td>
                        </tr>
                    </tbody>
                </table>

                <div class="row" v-if="false">
                    <div class="col col-6">
                        <pre>{{ lista_materiais }}</pre>
                    </div>
                    <div class="col col-6">
                        <pre>{{ lista }}</pre>
                    </div>
                </div>

            </template>

            <pre class="alert alert-info" v-if="false">{{ lista }}</pre>

            <!-- Modal -->
            <div class="modal fade" id="autorizarModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content" v-if="item">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                Ordem de Compra {{ item.fl_autorizado ? '' : 'Não' }} 
                                Autorizada #{{ item.id_aquisicao_ordem_compra }}
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="lead">
                                {{ item.fornecedor.search }}
                            </div>
                            <az-input
                                type="textarea"
                                label="Comentários"
                                :required="item.fl_autorizado === false"
                                :validate="validate"
                                v-model="item.st_comentarios" />
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <az-submit :color="item.fl_autorizado ? 'success' : 'danger'" @click="atualizar()">
                                {{ item.fl_autorizado ? 'Autorizar' : 'Não Autorizar' }}
                            </az-submit>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="ocModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ordem de Compra</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <ordem-de-compra-detalhe :oc_selecionada="item" modal="ocModal" @refresh="load()">
                            <template v-slot:autorizacao>
                                <div class="text-right" v-if="item.fl_autorizado === null">
                                    <button type="button" class="btn btn-success" @click="autorizar(item)">
                                        <i class="fas fa-check fa-fw "></i>
                                    </button>
                                    <button type="button" class="btn btn-danger ml-1" @click="autorizar(item, false)">
                                        <i class="fas fa-times fa-fw "></i>
                                    </button>
                                </div>
                            </template>
                        </ordem-de-compra-detalhe>

                        <template v-if="tabela">
                            <p class="alert bg-dark text-white mt-3">Mapa de Cotação</p>
                            <mapa-de-cotacao :viewonly="true" :tabela="tabela" v-if="tabela" />

                            <template v-if="tabela.log_envio_emails && tabela.log_envio_emails.length">
                                <p class="alert bg-dark text-white mt-3">Envios de e-mail</p>
                                <table class="table table-sm mt-3">
                                    <thead>
                                        <tr>
                                            <th>Envio e-mail</th>
                                            <th>Responsável</th>
                                            <th>Destinatário</th>
                                            <th>Assunto</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(envio, iex) in tabela.log_envio_emails" :key="iex">
                                            <td>
                                                {{ $util.getFormatDate(envio.created_at) }}
                                                {{ envio.created_at.slice(11,16) }}
                                            </td>
                                            <td>{{ envio.usuario ? envio.usuario.st_login : '' }}</td>
                                            <td>{{ envio.st_destinatario }}</td>
                                            <td>{{ envio.st_assunto }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item" model="aquisicaoOrdemCompra" :id="item.id_aquisicao_ordem_compra" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <registrar-contatos 
                :lista_status="lista_status ? lista_status : []" 
                :extra_parms="{}"
                ref="regcontatos" 
                titulo="Ordem de Compra"
                @refresh="load()">
                <template v-slot:info>
                    <template v-if="oc_contato">
                        Ordem de Compra: #{{ oc_contato.id_aquisicao_ordem_compra }}
                    </template>
                </template>
        </registrar-contatos>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import OrdemDeCompraDetalhe from './OrdemDeCompraDetalhe.vue';
import MapaDeCotacao from './MapaDeCotacao.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            metadados: null, 
            anos: [],
            unidade: "", 
            filtros: { 
                tipo_data: "", 
                inicio: this.$util.hoje(),
                fim: this.$util.hoje(),           
                id_unidade_operacao: "", 
                periodo: "s",
                status_aprovacao: "X", 
                status_recebimento: "", 
                id_fornecedor: "",
                id_estoque_item: "", 
                id_contato_status: "", 
                id_estoque_grupo: "", 
                busca_consig: "",
            },
            autorizador: false,
            tabela: null, 
            viewType: "OC",
            detalhado: true, 
            lista_status: null,  
            oc_contato: null,
        }
    },

    props: ['id'], 

    components: { 
        AzInput,
        AzEmptyState,
        AzPeriodo, 
        AzSubmit, 
        OrdemDeCompraDetalhe, 
        MapaDeCotacao, 
        AzAuditLogButton,
        RegistrarContatos, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter(item => !this.unidade || item.id_unidade_operacao == this.unidade)
                .filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( this.viewType == 'IT' || !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_classes: function () { 
            return _.uniq(
                this.lista_materiais.flatMap(item => item.classes)
            ).sort();
        },

        lista_materiais: function () { 
            if ( !this.lista || !this.lista.length )
                return [];

            let lista = _.orderBy(
                _.map(
                    _.groupBy(this.lista.flatMap(item => item.items.map(oci => { 
                            oci.fornecedor = item.fornecedor.st_nome_fantasia;
                            return oci;
                        })), 
                        'preco.item.id_estoque_item'
                    ),
                    items => { 

                        let info = { 
                            id: items[0].preco.item.id_estoque_item,
                            descricao: items[0].preco.item.search,
                            unidade: items[0].preco.item.st_unidade,
                            fornecedor: _.uniq(items.map(oc_item => oc_item.fornecedor)).sort().join(', '),
                            ocs: items.length, 
                            qtd_compra: _.sumBy(items, oc_item => parseFloat(oc_item.dc_quantidade)), 
                            qtd_receb: _.sumBy(
                                items.flatMap(oc_item => oc_item.nf_items), 
                                oc_item => parseFloat(oc_item.dc_quantidade)
                            ), 
                            qtd_pend: 0, 
                            cor: "", 
                            classes: _.get(items, '0.preco.item.estoque_item.js_classes'),
                        };

                        info.qtd_pend = info.qtd_compra > info.qtd_receb ? info.qtd_compra - info.qtd_receb : 0;

                        if ( ( info.qtd_receb > 0 ) && ( info.qtd_compra > info.qtd_receb ) ) { 
                            info.cor = 'warning';
                        } else if ( info.qtd_receb > 0 && !info.qtd_pend ) { 
                            info.cor = 'success';
                        }

                        return info;
                    },
                ),
                'descricao'
            );

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return lista.filter (item => { 
                return ( !this.search || reg.test(JSON.stringify(item)) );
            });

        }
    },

    methods: { 
        registrar_contatos (solic) { 
            this.oc_contato = _.cloneDeep(solic);

            this.oc_contato.nome_paciente = '#' + this.oc_contato.id_aquisicao_ordem_compra;
            
            this.oc_contato.model = { 
                type: 'aquisicaoOrdemCompra',
                id: this.oc_contato.id_aquisicao_ordem_compra, 
            };

            this.$refs.regcontatos.editar(this.oc_contato);
        },

        filtrar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = ""; 
            } else { 
                this.search = '"' + texto + '"';
            }   
        },

        view_oc (oc) { 
            this.tabela = null;
            this.item = _.cloneDeep(oc);

            this.carregar_tabela(oc);

            $('#ocModal').modal('show');
        },

        carregar_tabela (oc) { 
            this.tabela = null;
            this.validate = false;

            this.$util.loadItem(this, { 
                service: 'aquisicao',
                parms: { 
                    id: oc.id_aquisicao, 
                    id_estoque_grupo_local: oc.aquisicao.id_estoque_grupo_local, 
                    preco: true, 
                    oc_id_envios: oc.id_aquisicao_ordem_compra,
                },
            })
            .then(res => { 
                this.tabela = res;
            });
            
        },

        imprimir_oc (oc) { 
            this.$util.print_preview('imprimir/oc/' + oc.id_aquisicao_ordem_compra, true);
        },

        autorizar (oc, autorizar = true) { 
            $('.modal').modal('hide');

            this.item = _.cloneDeep(oc);
            this.item.fl_autorizado = autorizar;
            this.validate = false;

            $('#autorizarModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar (this, { 
                service: 'aquisicao_ordem_compras',
                func: 'autorizar_oc',
                dados: this.item,
                modal: 'autorizarModal',
                toast: true, 
                reload: true, 
            });
        },

        load () { 
            this.$util.load(this, { 
                service: 'aquisicao_ordem_compras',
                func: 'index',
                parms: { 
                    ...this.filtros, 
                    search: this.search, 
                    aprovacao: true, 
                    permissao: 27, 
                },
            });
        },
        
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'aquisicao_ordem_compras', 
                dados: item, 
            });

        },
    },

    beforeMount () { 
        if ( this.id ) { 
            this.search = '#' + this.id;
        }
    },

    mounted () { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Ordens de Compra", path: "/suprimentos/oc" }
        ]);

        this.load();

        this.$util.loadItem(this, { 
            service: 'usuarios',
            func: 'tem_permissao_acesso', 
            parms: { 
                resource_id: 17 
            }
        })
        .then(res => { 
            this.autorizador = res.pode;
        });

        this.$util.loadItem(this, { 
            service: 'contato_status', 
            func: 'index',
            parms: { 
                model: 'aquisicaoOrdemCompra', 
                ativos: true, 
            },
        })
        .then(res => { 
            this.lista_status = res;
        });

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>